enum UserFieldNames {
  Accesses = 'accesses',
  AssignationTitle = 'assignationTitle',
  AssignationType = 'assignationType',
  Assignations = 'assignations',
  AvatarAttached = 'avatarAttached',
  Email = 'email',
  FirstName = 'firstName',
  GenerateNewPassword = 'generateNewPassword',
  Lang = 'lang',
  LastName = 'lastName',
  Password = 'password',
  PersonalId = 'personalId',
  PhoneNumber = 'phoneNumber',
  Role = 'role',
  SectorMemberships = 'sectorMemberships',
  SiteMemberships = 'siteMemberships',
  Team = 'team',
  TeamAccesses = 'team-accesses',
  AccessesMessage = 'accesses-message',
  UnconfirmedEmail = 'unconfirmedEmail',
  Username = 'systemName',
}

export default UserFieldNames;
